import React, { useEffect, useState, useTransition } from 'react';

function UseTransition() {
	const [input, setInput] = useState('');
	const [pokemon, setPokemon] = useState([]);
	const [filteredPokemon, setFilteredPokemon] = useState([]);
	const [isPending, startTransition] = useTransition();

	useEffect(() => {
		const getPokemon = async () => {
			const res = await fetch('https://pokeapi.co/api/v2/pokemon');
			const data = await res.json();
			setPokemon(data.results);
		};
		getPokemon();
	}, []);

	const handleChange = (e) => {
		setInput(e.target.value.toLowerCase());
		startTransition(() => {
			setFilteredPokemon(
				pokemon.filter((poke: any) => poke.name.includes(input)),
			);
		});
	};

	return (
		<div>
			<input
				type="text"
				className="mb-2"
				onChange={handleChange}
				value={input}
			/>
			{isPending && <p>Loading...</p>}
			{filteredPokemon?.map((poke: any) => (
				<div
					key={Math.random()}
					className="mb-2"
				>
					<h1 className="font-bold">{poke.name}</h1>
				</div>
			))}
		</div>
	);
}

export default UseTransition;
